import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Log } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class LogModule extends VuexModule {
    @Action
    [Log.findPageLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/findPage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}